import axios from 'axios'

export class ApiError extends Error {
  status: number
  code: string
  details: Record<string, unknown> | undefined
  requestId: string | undefined

  constructor(args: {
    status: number
    code: string
    message: string
    details?: Record<string, unknown>
    requestId?: string
  }) {
    super(args.message)
    this.name = 'ApiError'
    this.status = args.status
    this.code = args.code
    this.details = args.details
    this.requestId = args.requestId
  }
}

export function parseApiError(err: unknown): ApiError {
  if (axios.isAxiosError(err)) {
    const status = err.response?.status ?? 0
    const data = err.response?.data as
      | { error?: { code?: string; message?: string; details?: Record<string, unknown> }; request_id?: string }
      | undefined
    return new ApiError({
      status,
      code: data?.error?.code ?? 'UNKNOWN_ERROR',
      message: data?.error?.message ?? err.message,
      details: data?.error?.details,
      requestId: data?.request_id,
    })
  }
  if (err instanceof Error) {
    return new ApiError({ status: 0, code: 'UNKNOWN_ERROR', message: err.message })
  }
  return new ApiError({ status: 0, code: 'UNKNOWN_ERROR', message: String(err) })
}

export function formatErrorMessage(err: unknown): string {
  if (err instanceof ApiError) return err.message
  if (err instanceof Error) return err.message
  return String(err)
}
